import Routes from './routes';
import { useInitSSO } from './hooks';

const App = () => {
  useInitSSO();

  return <Routes />;
};

export default App;
